import { render, staticRenderFns } from "./DetailModalRow.vue?vue&type=template&id=596a3553&scoped=true&"
import script from "./DetailModalRow.vue?vue&type=script&lang=js&"
export * from "./DetailModalRow.vue?vue&type=script&lang=js&"
import style0 from "./DetailModalRow.vue?vue&type=style&index=0&id=596a3553&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a3553",
  null
  
)

export default component.exports